import React, { FC } from 'react';

import './adr.css';

export interface AdrSearchResultProps {
  link: string;
  date: string;
  path: string;
  status: string;
  title: string;
  entityref?: string;
  content: string;
  type: string;
  selectedTag?: string[];
}

const AdrSearchResultListItem: FC<{ data: AdrSearchResultProps }> = ({
  data,
}) => {
  const fullLink = '/catalog/default/'
    .concat(data?.entityref?.split(':')[0] as string)
    .concat('/')
    .concat(data?.entityref?.split('/')[1] as string)
    .concat('/adr/')
    .concat(data.path);

  const onLinkClick = (url: string) => {
    return window.open(url, '_blank');
  };

  return (
    <>
      <div>
        <div
          className="adrLink"
          onClick={() => onLinkClick(fullLink)}
          role="button"
          tabIndex={-1}
          onKeyDown={() => onLinkClick('')}
        >
          {data?.title}
        </div>
        <div
          className="adrContent"
          dangerouslySetInnerHTML={{
            __html: data?.content?.substring(0,100),
          }}
        />
      </div>
      <div className="adrSubContentContainer">
        <div className="adrSubContentContainer__content">
          Entity: {data?.entityref?.split(':')[0] as string}
        </div>
        {data?.date && (
          <div className="adrSubContentContainer__content">
            Date: {data?.date}
          </div>
        )}
        {data?.status && (
          <div className="adrSubContentContainer__content">
            Status: {data?.status}
          </div>
        )}
      </div>
      <hr />
    </>
  );
};

export default AdrSearchResultListItem;
